const DEFAULT_MESSAGE = "Une erreur s'est produite";

export default {
    DEFAULT_MESSAGE: DEFAULT_MESSAGE,
    QUOTATION_VAT_REQUIRED: "Merci de renseigner la TVA"
}
